import { useNavigate } from "react-router-dom";
import { fetchCurrentUser } from "api/authApi";
import routes from "helpers/routes";
import { useRQuery } from "./reactQueryHelper";
import { User } from "components/models";

type Params = {
    onSuccess?: () => void,
    onError?: (error: { message?: string }) => void,
};

/**
 * Fetch the current user, or redirects to login page if not logged in and route is not public.
 */
export const useUserData = (params?: Params) => {
    const navigate = useNavigate();

    return useRQuery<User>('user', fetchCurrentUser, {
        onSuccess: params?.onSuccess,
        onError: (error: any) => {
            // Check if current route is public
            const currentRoute = Object.values(routes).find(route => route.path === window.location.pathname);
            const isPublicRoute = currentRoute?.public === true;

            if (error?.code === "ERR_BAD_REQUEST" && window.location.pathname !== routes.Login.path && !isPublicRoute)  // 401 and not public
                navigate(`${routes.Login.path}?returnUrl=${window.location.pathname}`);

            params?.onError && params?.onError(error);
        },
        cacheTime: 90 * 24 * 60 * 60 * 1000, // 90 days
        staleTime: 60 * 60 * 1000, // 1 hour = fresh
        refetchOnWindowFocus: false,
        keepPreviousData: false,
        retry: false,
    });
}